import {
  Box,
  Button,
  FormControl,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { FC } from 'react';
import { ButtonStyled } from '../StyledComponents/StyledPageComponents';

interface LogoUploadProps {
  imagePreview: string | ArrayBuffer | null;
  fileInputRef: React.RefObject<HTMLInputElement>;
  onFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onClick: () => void;
}

const LogoUpload: FC<LogoUploadProps> = ({
  imagePreview,
  fileInputRef,
  onFileChange,
  onClick,
}) => {
  const theme = useTheme();
  const smScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <>
      <Typography
        fontFamily="Outfit"
        fontWeight="400"
        fontSize="16px"
        color="var(--primary-navy)"
        mt={2}
        mb={2}
      >
        Company Logo
      </Typography>

      <Box display="flex" alignItems="center">
        <Box
          sx={{
            width: 100,
            height: 100,
            borderRadius: '50%',
            border: '2px solid var(--border)',
            overflow: 'hidden',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'var(--text-bg)',
            boxShadow: smScreen ? 'none' : '0px 0px 10px rgba(0,0,0,0.1)',
            mr: 5,
          }}
        >
          {imagePreview ? (
            <img
              src={imagePreview as string}
              alt="Preview"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
              }}
            />
          ) : (
            <Typography
              fontFamily="Outfit"
              fontWeight="400"
              fontSize="16px"
              color="var(--primary-navy)"
              textAlign="center"
            >
              No Image
            </Typography>
          )}
        </Box>
        <FormControl>
          <ButtonStyled
            className="btn-primary"
            fullWidth
            type="button"
            onClick={onClick}
            sx={{
              mt: 1,
              width: smScreen ? '100%' : '150px',
              fontFamily: 'Outfit',
              fontSize: '16px',
              fontWeight: '500',
            }}
          >
            Upload Logo
          </ButtonStyled>
          <input
            type="file"
            accept="image/*"
            ref={fileInputRef}
            onChange={onFileChange}
            style={{ display: 'none' }}
          />
        </FormControl>
      </Box>
    </>
  );
};

export default LogoUpload;
